import { createSelector } from 'reselect';

const selectContacts = (state: any) => state.contacts;


export const selectCurrentItem = createSelector([selectContacts], (contacts) => contacts.current);

export const selectListItems = createSelector([selectContacts], (contacts) => contacts.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectContacts], (contacts) => contacts.create);

export const selectUpdatedItem = createSelector([selectContacts], (contacts) => contacts.update);

export const selectReadItem = createSelector([selectContacts], (contacts) => contacts.read);

export const selectDeletedItem = createSelector([selectContacts], (contacts) => contacts.delete);

export const selectSearchedItems = createSelector([selectContacts], (contacts) => contacts.search);

export const selectItemsCount = createSelector([selectContacts], (contacts) => contacts.count);

export const selectItemsFilter = createSelector([selectContacts], (contacts) => contacts.filter);